import { CustomPalette } from '@customTypes/createPalette'
import { Global } from '@emotion/react'

const CSSVariables = ({ theme }: { theme: CustomPalette }) => {
	const { backgroundColors, borderColors, fonts } = theme
	const vars: string[] = []

	;[backgroundColors, borderColors, fonts].forEach(el => {
		Object.entries(el).forEach(([key, val]) => vars.push(`--${key}: ${val};`))
	})
	return <Global styles={vars.join('')} />
}

export { CSSVariables }
